import { TOGGLE_FILTER } from './../const';

export default (attribute) => {
    return { type: TOGGLE_FILTER, attribute };
}
